"use strict";

exports.__esModule = !0, exports.default = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base")),
  _react = _interopRequireDefault(require("react")),
  _constants = require("../constants");
function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Separator = function (a) {
    var b = a.props,
      c = a.state,
      d = a.methods;
    return b.separatorRenderer ? b.separatorRenderer({
      props: b,
      state: c,
      methods: d
    }) : /*#__PURE__*/_react.default.createElement(SeparatorComponent, {
      className: _constants.LIB_NAME + "-separator"
    });
  },
  SeparatorComponent = /*#__PURE__*/(0, _base.default)("div", "production" === process.env.NODE_ENV ? {
    target: "e19h5j1v0"
  } : {
    target: "e19h5j1v0",
    label: "SeparatorComponent"
  })("production" === process.env.NODE_ENV ? {
    name: "cmi1n0",
    styles: "border-left:1px solid #ccc;width:1px;height:25px;display:block"
  } : {
    name: "cmi1n0",
    styles: "border-left:1px solid #ccc;width:1px;height:25px;display:block",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL1NlcGFyYXRvci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFXcUMiLCJmaWxlIjoiLi4vLi4vc3JjL2NvbXBvbmVudHMvU2VwYXJhdG9yLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IExJQl9OQU1FIH0gZnJvbSAnLi4vY29uc3RhbnRzJztcblxuY29uc3QgU2VwYXJhdG9yID0gKHsgcHJvcHMsIHN0YXRlLCBtZXRob2RzIH0pID0+XG4gIHByb3BzLnNlcGFyYXRvclJlbmRlcmVyID8gKFxuICAgIHByb3BzLnNlcGFyYXRvclJlbmRlcmVyKHsgcHJvcHMsIHN0YXRlLCBtZXRob2RzIH0pXG4gICkgOiAoXG4gICAgPFNlcGFyYXRvckNvbXBvbmVudCBjbGFzc05hbWU9e2Ake0xJQl9OQU1FfS1zZXBhcmF0b3JgfSAvPlxuICApO1xuXG5jb25zdCBTZXBhcmF0b3JDb21wb25lbnQgPSBzdHlsZWQuZGl2YFxuICBib3JkZXItbGVmdDogMXB4IHNvbGlkICNjY2M7XG4gIHdpZHRoOiAxcHg7XG4gIGhlaWdodDogMjVweDtcbiAgZGlzcGxheTogYmxvY2s7XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBTZXBhcmF0b3I7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }),
  _default = Separator;
exports.default = _default;